import { computed } from '@angular/core';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { HistoryState } from './history.state';
import { History } from '../../models/history';

export function withHistorySelectors() {
  return signalStoreFeature(
    {
      state: type<HistoryState>(),
    },
    withMethods(store => ({
      filterByType(type: string) {
        return Object.values(store.items()).filter(item => {
          return item.entityType === type;
        }) as History[];
      },
    })),
    withComputed(({ items }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => Object.values(items())),
      asGroupedByType: computed(() => {
        return Object.values(items()).reduce(
          (acc: { [key: string]: History[] }, item: History) => {
            acc[item.entityType] = acc[item.entityType] || [];
            acc[item.entityType].push(item);
            return acc;
          },
          {}
        );
      }),
    }))
  );
}
